import { GetContentOptions } from '@builder.io/sdk';
import { BuilderContent } from '@builder.io/react';

import { Locale } from '@/helpers/LangHelper';
import { BUILDER_CORE_API_KEY } from '@/shared/env';

interface BuilderResult<>extends Omit<BuilderContent, 'data'> {}

interface BuilderFetchObjectResult<T> extends BuilderResult {
    data: T;
}

export class CoreSiteBaseModel<DataType extends Object> {
    private baseURL = 'https://cdn.builder.io/api/v3/content/';
    private model = '';

    constructor(model: string) {
        this.model = model;
    }

    protected getURL = () => {
        return `${this.baseURL}${this.model}`;
    };

    protected buildQueryString = (params: GetContentOptions) => {
        const searchParams = new URLSearchParams({
            apiKey: BUILDER_CORE_API_KEY,
        });

        if (params.locale) {
            searchParams.append('userAttributes.locale', params.locale);
        }

        if (params.limit) {
            searchParams.append('limit', `${params.limit}`);
        }

        if (params.offset) {
            searchParams.append('limit', `${params.offset}`);
        }

        return `${this.getURL()}?${searchParams.toString()}`;
    };

    public find = async (locale: Locale): Promise<BuilderFetchObjectResult<DataType>[]> => {
        const url = this.buildQueryString({ locale });

        const rs = await fetch(url);
        const builderContent = (await rs.json()) as { results: BuilderFetchObjectResult<DataType>[] };
        return builderContent.results;
    };
}
